import { Button, Upload } from 'antd';
import React, { ReactElement, useState } from 'react';
import { UploadChangeParam, UploadFile, UploadProps } from 'antd/lib/upload/interface';
import { fileBeforeUpload } from '../../../../utils/fileUploadUtils';
import { GLOBAL_URL } from '../../../../shared/constants/dataServiceUrl';
import { centeredNotification } from '../../../../utils/utility';
import { COMMON_ERROR } from '../../../../shared/constants/commonConstants';
import { ReactComponent as UploadIcon} from '../../../../assets/images/svg/upload_icon.svg';

const Uploader = ({files, setFileListObj}: any): ReactElement => {
  const [isUploading, setIsUploading] = useState(false);
  const fileList: UploadFile<any>[] = [];
  const uploadFiles = (linkedTo: string): any => {
    const draggerActions: UploadProps = {
      showUploadList: true,
      fileList: files[linkedTo] || [],
      beforeUpload: fileBeforeUpload,
      multiple: true,
      action: GLOBAL_URL.CRM_BASE_URL + 'Provider/File/Upload',
      withCredentials : true,
      onChange: (info: UploadChangeParam<UploadFile<any>>): any => {
        if (info?.file?.status === 'done') {
          const { isSuccess, errorMessage } = info?.file?.response || {};
          if (isSuccess) {
            fileList.push(info?.file);
            setFileListObj({...files, [linkedTo]: fileList });
          } else {
            centeredNotification(errorMessage || COMMON_ERROR);
          }
          const allDone = info?.fileList?.every(({ status }: UploadFile): boolean => !status || status === 'done');
          if (allDone) {
            setIsUploading(false);
          } else {
            setIsUploading(true);
          }
        }
      },
    };
    return draggerActions;
  };
  return (
    <div className="reconciliate-modal-card mouse-pointer">
      <Upload
        {...uploadFiles('FinanceReport')}
        className="reconciliation-file-upload"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        itemRender={(): any => null}
        maxCount={1}>
          <div className="flex flex-element flex-row items-center gap-5">
          <Button type="text" icon={<UploadIcon />} loading={isUploading}/>
            <div>
              <div className="record-heading">
                Financial Statement Template
              </div>
              <div className="record-format">
                (File format needs to be .xlsx)
              </div>
            </div>
          </div>
      </Upload>
    </div>
  );
};
export default Uploader;
